import React from "react";
import { motion } from "framer-motion";
import content from "../content/content.json";

const columnVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

const Insights = () => {
  const { insightsMenu } = content;

  return (
    <motion.div
      className="absolute top-full h-screen left-0 w-full bg-white shadow-lg z-50 py-12"
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      <div className="grid md:grid-cols-3 h-full">
        <motion.div className="bg-gray-300 p-8 h-full flex flex-col" custom={0} variants={columnVariants}>
          <h3 className="font-semibold text-3xl mb-6 text-[#1C1F2B]">{insightsMenu.title}</h3>
          <p className="text-sm text-[#1C1F2B] leading-loose">{insightsMenu.description}</p>
        </motion.div>

        <motion.div className="bg-gray-100 p-8 h-full" custom={1} variants={columnVariants}>
          <h4 className="text-sm font-bold text-[#1C1F2B] mb-6">{insightsMenu.featuredHeading}</h4>
          <ol className="space-y-3 text-lg text-gray-700">
            {insightsMenu.featuredTopics.map((topic) => (
              <li key={topic} className="hover:text-[#D00] cursor-pointer">
                {topic}
              </li>
            ))}
          </ol>
        </motion.div>

        <motion.div className="bg-gray-50 p-8 h-full" custom={2} variants={columnVariants}></motion.div>
      </div>
    </motion.div>
  );
};

export default Insights;

